import { useState, useEffect } from "react";

type PostSummary = {
  id: number;
  title: string;
  slug: string;
  published: 0 | 1;
  created_at: string;
  updated_at: string;
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function BlogList() {
  const [posts, setPosts] = useState<PostSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isAdmin] = useState(!!localStorage.getItem("blog_token"));

  useEffect(() => {
    fetch("/api/posts")
      .then((r) => r.json())
      .then((data) => setPosts(data as PostSummary[]))
      .catch(() => setError("Beiträge konnten nicht geladen werden."));
  }, []);

  return (
    <div className="portfolio blog-layout">
      <div className="noise-overlay" aria-hidden="true" />

      <nav className="nav nav--scrolled">
        <a href="#" className="nav-logo">NK</a>
        <div className="nav-links">
          {isAdmin && (
            <a href="#admin" className="nav-link" title="Go to admin panel">
              ⚙ Admin
            </a>
          )}
          <a href="#" className="nav-link">← Zurück</a>
        </div>
      </nav>

      <section className="blog-page">
        <div className="container">
          <header className="section-header">
            <span className="section-num">✦</span>
            <h1 className="section-title">Blog</h1>
          </header>

          <div className="blog-list">
            {!posts && !error && (
              <p className="blog-empty">Lade Beiträge…</p>
            )}
            {error && <p className="blog-empty">{error}</p>}
            {posts && posts.length === 0 && (
              <p className="blog-empty">Noch keine Beiträge veröffentlicht.</p>
            )}
            {posts && posts.map((post) => (
              <a
                key={post.id}
                href={`#blog/${post.slug}`}
                className="blog-card"
              >
                <div className="blog-card-body">
                  <h2 className="blog-card-title">{post.title}</h2>
                  <time className="blog-card-date" dateTime={post.created_at}>
                    {formatDate(post.created_at)}
                  </time>
                </div>
                <span className="blog-card-arrow">→</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <span>© 2026 Nicolai Kobras</span>
        <a href="#impressum" className="footer-link">Impressum</a>
      </footer>
    </div>
  );
}
